import format from "date-fns/format";
import notify from "../../components/UI/toast";

export const validAirfare = async (airfareState) => {

    if (!airfareState.locationDeparture.code) {
        notify('Por favor, insira o local de origem', 'warn')
        return false
    }
    if (!airfareState.locationArrival.code) {
        notify('Por favor, insira o local de destino', 'warn')
        return false
    }
    if (!airfareState.datesSearchAirfare.startDate) {
        notify('Por favor, selecione a data de ida', 'warn')
        return false
    }

    if (!airfareState.onlyDeparture && !airfareState.datesSearchAirfare.endDate) {
        notify('Por favor, selecione a data de volta', 'warn')
        return false
    }
    return true
}

export const generateRedirectUrl = async (airfareState) => {

    const startDate = airfareState.datesSearchAirfare.startDate ? format(airfareState.datesSearchAirfare.startDate, "yyyy-MM-dd") : ''
    const endDate = airfareState.datesSearchAirfare.endDate ? format(airfareState.datesSearchAirfare.endDate, "yyyy-MM-dd") : ''


    return `${process.env.REACT_APP_FRACTAL}/voos?query=form`+
        `&from=${airfareState.locationDeparture.name}`+
        `$to=${airfareState.locationArrival.name}`+
        `&from_date=${startDate}`+
        `&to_date=${endDate}`+
        `&class=${airfareState.classAirfare}`+
        `&payment_method=${airfareState.offersAirfare === 'points' ? 'points' : 'money' }`+
        `&from-date=${startDate}`+
        `&from-date-formatted=`+
        `&to-date=${endDate}`+
        `&to-date-formatted=`+
        `&from-code=${airfareState.locationDeparture.code}`+
        `&from-code-formatted=`+
        `&from-main-code=${airfareState.locationDeparture.main_code}`+
        `&from-country-code=${airfareState.locationDeparture.country_code}`+
        `&to-code=${airfareState.locationArrival.code}`+
        `&to-main-code=${airfareState.locationArrival.main_code}`+
        `&to-country-code=${airfareState.locationArrival.country_code}`+
        `&from-name=${airfareState.locationDeparture.name}`+
        `&to-name=${airfareState.locationArrival.name}`+
        `&type=${!endDate ? 0 : 1}`+
        `&direct=0`+
        `&cabin=${airfareState.classAirfare}`+
        `&adults=${airfareState.numberOfPassengers.adults}`+
        `&children=${airfareState.numberOfPassengers.children}`+
        `&baby=${airfareState.numberOfPassengers.baby}`

}